import React from 'react';

export type DashboardIconType =
  | 'activity'
  | 'alert'
  | 'assignment'
  | 'arrow-up'
  | 'card'
  | 'close'
  | 'database'
  | 'driver'
  | 'edit'
  | 'eye'
  | 'lock'
  | 'passenger'
  | 'pulse'
  | 'response'
  | 'route'
  | 'sessions'
  | 'shield'
  | 'trend-down'
  | 'trend-up'
  | 'truck'
  | 'user'
  | 'users'
  | 'vehicle'
  | 'wallet'
  | 'warning';

type DashboardIconProps = {
  type: DashboardIconType;
  size?: number;
};

export function DashboardIcon({ type, size = 18 }: DashboardIconProps) {
  const paths: Record<DashboardIconType, React.ReactNode> = {
    activity: <path d="M3 12h4l3-9 4 18 3-9h4" />,
    alert: (
      <>
        <path d="M12 3L2.5 20h19L12 3z" />
        <path d="M12 9v5M12 17h.01" />
      </>
    ),
    assignment: (
      <>
        <rect x="5" y="4" width="14" height="17" rx="2" />
        <path d="M9 4V2h6v2M9 10h6M9 14h6M9 18h4" />
      </>
    ),
    'arrow-up': <path d="M18 15l-6-6-6 6" />,
    card: (
      <>
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18M7 15h4" />
      </>
    ),
    close: <path d="M6 6l12 12M18 6L6 18" />,
    database: (
      <>
        <ellipse cx="12" cy="5" rx="7" ry="3" />
        <path d="M5 5v14c0 1.7 3.1 3 7 3s7-1.3 7-3V5M5 12c0 1.7 3.1 3 7 3s7-1.3 7-3" />
      </>
    ),
    driver: (
      <>
        <circle cx="12" cy="8" r="3" />
        <path d="M5 21a7 7 0 0114 0M7 8h10M9 5h6" />
      </>
    ),
    edit: (
      <>
        <path d="M4 20h4l10-10-4-4L4 16v4z" />
        <path d="M13 7l4 4" />
      </>
    ),
    eye: (
      <>
        <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    lock: (
      <>
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path d="M8 10V7a4 4 0 018 0v3M12 14v3" />
      </>
    ),
    passenger: (
      <>
        <circle cx="12" cy="7" r="3" />
        <path d="M6 21v-3a6 6 0 0112 0v3M9 12l3 3 3-3" />
      </>
    ),
    pulse: <path d="M3 12h4l2-7 4 14 3-9 2 2h3" />,
    response: <path d="M4 14h4l2-8 4 14 2-8h4" />,
    route: (
      <>
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="6" r="3" />
        <path d="M8.5 16c4-2 7-4 7-7" />
      </>
    ),
    sessions: (
      <>
        <circle cx="12" cy="8" r="3.5" />
        <path d="M5.5 20a6.5 6.5 0 0113 0" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
        <path d="M9 12l2 2 4-5" />
      </>
    ),
    'trend-down': <path d="M7 10l5 5 5-5" />,
    'trend-up': <path d="M7 14l5-5 5 5" />,
    truck: (
      <>
        <path d="M3 6h12v10H3zM15 10h4l2 3v3h-6z" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="18" cy="18" r="2" />
      </>
    ),
    user: (
      <>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0116 0" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3 20a6 6 0 0112 0M16 5a3 3 0 010 6M17 14a5 5 0 014 5" />
      </>
    ),
    vehicle: (
      <>
        <path d="M5 17h14l-1-7a2 2 0 00-2-2H8a2 2 0 00-2 2l-1 7zM3 14h18" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="17" cy="18" r="2" />
      </>
    ),
    wallet: (
      <>
        <path d="M4 6h14a2 2 0 012 2v10H4a2 2 0 01-2-2V6h2z" />
        <path d="M4 6V4h12v2M15 11h5v4h-5a2 2 0 010-4z" />
      </>
    ),
    warning: (
      <>
        <path d="M12 3L2.5 20h19L12 3z" />
        <path d="M12 9v5M12 17h.01" />
      </>
    ),
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      {paths[type]}
    </svg>
  );
}
